<template>
	<div class="license" style="font-size: 14px; margin-top: 10px">
		<template v-if="isDomLoading">
			<TaskSkeletonLoader />
		</template>
		<el-card
			v-if="show_tab"
			style="border-bottom: none; border-radius: 12px"
			shadow="none"
		>
			<span v-for="(item, idx) in currentTabItems" :key="idx">
				<span
					@click="change_tab(idx)"
					style="margin-right: 30px; font-size: 16px; cursor: pointer"
					:style="item.active ? 'font-weight:bold' : ''"
					>{{ item.name }}</span
				>
			</span>
		</el-card>
		<div
			style="margin-top: 10px"
			v-if="current_view == 'LIST' && currentTabItems[0].active"
		>
			<div style="display: flex">
				<div class="search-col" style="width: 30%">
					<input
						type="text"
						v-model="search"
						placeholder="Search by location or license"
						class="searchicon"
						@input="handleInput"
					/>
				</div>
				<div style="margin-left: auto">
					<el-button
						icon="el-icon-circle-plus-outline"
						class="button-class-white"
						@click="toggle_actions('ADD')"
					>
						Add License
					</el-button>

					<el-button
						icon="el-icon-download"
						@click="downloadCSV"
						class="button-class"
					>
						Download CSV
					</el-button>
				</div>
			</div>
			<el-row class="license-table" style="margin-top: 10px">
				<el-col :span="24">
					<el-table
						class="responsive-table"
						style="
							text-transform: capitalize;
							word-break: break-word;
							width: 100%;
						"
						:data="
							computedLicenseTableData.filter(
								(el, index) => index >= startNumber - 1 && index < endNumber
							)
						"
					>
						<el-table-column label="Location">
							<template slot="header" slot-scope="scope">
								Location
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_Location"
										size="mini"
										placeholder="Search Location"
									></el-input>
									<div
										style="max-height: 200px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_Location">
											<el-checkbox
												v-for="(formItem, index) in uniqueLocationNames.filter(
													(el) =>
														!searched_Location ||
														el
															.toLowerCase()
															.includes(searched_Location.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div
										style="text-align: center"
										v-if="
											uniqueLocationNames.filter(
												(el) =>
													!searched_Location ||
													el
														.toLowerCase()
														.includes(searched_Location.toLowerCase())
											).length == 0
										"
									>
										No results found
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_Location = [...uniqueLocationNames]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_Location = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_Location.length"
											src="../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div style="text-transform: capitalize; word-break: break-word">
									{{
										scope.row.location != undefined ? scope.row.location : "-"
									}}
								</div>
							</template>
						</el-table-column>
						<el-table-column
							prop="name"
							label="License"
							style="word-break: break-word"
						>
							<template slot="header" slot-scope="scope">
								License
								<el-popover width="300" placement="right" trigger="click">
									<el-input
										v-model="searched_license"
										size="mini"
										placeholder="Search License"
									></el-input>
									<div
										style="max-height: 200px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_license">
											<el-checkbox
												v-for="(formItem, index) in uniqueLicense.filter(
													(el) =>
														!searched_license ||
														el
															.toLowerCase()
															.includes(searched_license.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block; width: 100%"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div
										style="text-align: center"
										v-if="
											uniqueLicense.filter(
												(el) =>
													!searched_license ||
													el
														.toLowerCase()
														.includes(searched_license.toLowerCase())
											).length == 0
										"
									>
										No results found
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_license = [...uniqueLicense]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_license = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_license.length"
											src="../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div style="word-break: break-word">
									{{ scope.row.name != 0 ? scope.row.name : "-" }}
								</div>
							</template>
						</el-table-column>
						<el-table-column
							prop="region"
							label="Region"
							width="150px"
							style="word-break: break-word"
						>
							<template slot="header" slot-scope="scope">
								Region
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_Region"
										size="mini"
										placeholder="Search Region"
									></el-input>
									<div
										style="max-height: 200px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_Region">
											<el-checkbox
												v-for="(formItem, index) in uniqueRegion.filter(
													(el) =>
														!searched_Region ||
														el
															.toLowerCase()
															.includes(searched_Region.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div
										style="text-align: center"
										v-if="
											uniqueRegion.filter(
												(el) =>
													!searched_Region ||
													el
														.toLowerCase()
														.includes(searched_Region.toLowerCase())
											).length == 0
										"
									>
										No results found
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_Region = [...uniqueRegion]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_Region = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_Region.length"
											src="../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column
							prop="subregion"
							label="Sub Region"
							style="word-break: break-word"
							width="150px"
						>
							<template slot="header" slot-scope="scope">
								Sub Region
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_SubRegion"
										size="mini"
										placeholder="Search SubRegion"
									></el-input>
									<div
										style="max-height: 200px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_SubRegion">
											<el-checkbox
												v-for="(formItem, index) in uniqueSubRegion.filter(
													(el) =>
														!searched_SubRegion ||
														el
															.toLowerCase()
															.includes(searched_SubRegion.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div
										style="text-align: center"
										v-if="
											uniqueSubRegion.filter(
												(el) =>
													!searched_SubRegion ||
													el
														.toLowerCase()
														.includes(searched_SubRegion.toLowerCase())
											).length == 0
										"
									>
										No results found
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_SubRegion = [...uniqueSubRegion]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_SubRegion = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_SubRegion.length"
											src="../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column
							width="140px"
							prop="issue_date"
							style="word-break: break-word"
						>
							<template slot="header" slot-scope="scope">
								Issue Date
								<span slot="reference" class="cursor-pointer">
									<i
										v-if="issue_date_order == 'dsc'"
										class="el-icon-caret-top"
										style="font-size: 12px"
										v-on:click="
											issue_date_order = 'asc';
											expiry_date_order = '';
										"
									></i>
									<i
										v-if="issue_date_order == '' || issue_date_order == 'asc'"
										class="el-icon-caret-bottom"
										style="font-size: 12px"
										v-on:click="
											issue_date_order = 'dsc';
											expiry_date_order = '';
										"
									></i>
								</span>
							</template>
							<template slot-scope="scope">
								<span>{{
									moment(scope.row.issue_date).format("Do MMM YYYY")
								}}</span>
							</template>
						</el-table-column>
						<el-table-column
							width="140px"
							prop="expiry_date"
							style="word-break: break-word"
						>
							<template slot="header" slot-scope="scope">
								Expiry Date
								<span slot="reference" class="cursor-pointer">
									<i
										v-if="expiry_date_order == 'dsc'"
										class="el-icon-caret-top"
										style="font-size: 12px"
										v-on:click="
											expiry_date_order = 'asc';
											issue_date_order = '';
										"
									></i>
									<i
										v-if="expiry_date_order == '' || expiry_date_order == 'asc'"
										class="el-icon-caret-bottom"
										style="font-size: 12px"
										v-on:click="
											expiry_date_order = 'dsc';
											issue_date_order = '';
										"
									></i>
								</span>
							</template>
							<template slot-scope="scope">
								<span>{{
									moment(scope.row.expiry_date).format("Do MMM YYYY")
								}}</span>
							</template>
						</el-table-column>
						<el-table-column width="140px" prop="status">
							<template slot="header" slot-scope="scope">
								Status
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_Status"
										size="mini"
										placeholder="Search Status"
									></el-input>
									<div
										style="max-height: 200px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_Status">
											<el-checkbox
												v-for="(formItem, index) in uniqueStatus.filter(
													(el) =>
														!searched_Status ||
														el
															.toLowerCase()
															.includes(searched_Status.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div
										style="text-align: center"
										v-if="
											uniqueStatus.filter(
												(el) =>
													!searched_Status ||
													el
														.toLowerCase()
														.includes(searched_Status.toLowerCase())
											).length == 0
										"
									>
										No results found
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_Status = [...uniqueStatus]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_Status = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_Status.length"
											src="../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<el-tag
									size="small"
									style="border-radius: 12px; width: 80px; text-align: center"
									:style="
										scope.row.status == 'active'
											? 'border-color:#41BE62; background-color:#FFF9F4; color:#41BE62'
											: 'border-color:#D0342C; background-color:#FFF9F4; color:#D0342C'
									"
									>{{ scope.row.status == "active" ? "Active" : "Expired" }}
								</el-tag>
								<div
									style="text-align: left; color: red; font-size: 10px"
									v-if="scope.row.upcoming_renewal"
								>
									Upcoming renewal
								</div>
							</template>
						</el-table-column>
						<el-table-column width="40px" show-overflow-tooltip>
							<template slot-scope="scope">
								<span
									v-if="scope.row.attachments.length != 0"
									@click="toggle_actions('VIEW', scope.row)"
									style="color: #d26300; cursor: pointer"
									><u>View</u></span
								>
							</template>
						</el-table-column>
						<el-table-column width="90px" show-overflow-tooltip>
							<template slot-scope="scope">
								<span
									v-if="scope.row.upcoming_renewal"
									@click="toggle_actions('RENEWAL_ADD', scope.row)"
									style="color: #d26300; margin-left: 10px; cursor: pointer"
									><u>Renewal</u></span
								>
							</template>
						</el-table-column>
						<el-table-column width="50px">
							<template slot-scope="scope">
								<img
									@click="toggle_actions('EDIT', scope.row)"
									width="15px"
									class="mr-5"
									src="../../../assets/icons/EditIcon.png"
									style="cursor: pointer"
								/>
								<!-- <img
									@click="toggle_actions('DELETE', scope.row)"
									style="cursor: pointer"
									width="13px"
									src="../../../assets/icons/Union.png"
								/> -->
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
			<el-row :gutter="10" class="mt-3">
				<el-col :span="8" class="text-left">
					<div>
						<b>Showing</b> {{ startNumber }} to {{ endNumber }} of
						{{ list_count }} results
					</div>
				</el-col>
				<el-col :span="8" class="text-center">
					<el-select
						v-model="perPage"
						name="per_page"
						placeholder="select per page"
						style="width: 90px !important"
						size="mini"
					>
						<el-option label="10" :value="10"></el-option>
						<el-option label="25" :value="25"></el-option>
						<el-option label="50" :value="50"></el-option>
						<el-option label="100" :value="100"></el-option>
					</el-select>
					&nbsp;<b>per page</b>
				</el-col>
				<el-col :span="8" class="text-right">
					<el-pagination
						v-model="pagination"
						@current-change="get_page"
						background
						layout="prev, pager, next"
						:total="list_count"
						:page-size="perPage"
						:current-page.sync="currentPage"
					></el-pagination>
				</el-col>
			</el-row>
		</div>
		<div v-if="currentTabItems[1].active">
			<LicenseSettingsVue
				@hide_tab="show_tab = false"
				@show_tab="show_tab = true"
			/>
		</div>
		<div
			v-if="
				current_view == 'ADD' ||
				current_view == 'EDIT' ||
				current_view == 'VIEW' ||
				current_view == 'RENEWAL' ||
				current_view == 'RENEWAL_ADD'
			"
		>
			<el-row>
				<el-col :span="1">
					<img
						@click="
							current_view == 'VIEW'
								? ((current_view = 'LIST'),
								  (previewLicenseDialog = false),
								  (show_tab = true))
								: previewLicenseDialog
								? (previewLicenseDialog = false)
								: ((current_view = 'LIST'), (show_tab = true))
						"
						width="35px"
						src="../../../assets/icons/Back Arrow.png"
						style="cursor: pointer"
					/>
				</el-col>
				<el-col
					style="
						margin-top: 0px;
						color: #999999;
						margin-left: -10px;
						font-size: 16px;
					"
					:span="10"
				>
					<div
						style="margin-top: 8px"
						@click="
							current_view == 'VIEW'
								? ((current_view = 'LIST'),
								  (previewLicenseDialog = false),
								  (show_tab = true))
								: previewLicenseDialog
								? (previewLicenseDialog = false)
								: ((current_view = 'LIST'), (show_tab = true))
						"
					>
						Back
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<AddLicenseVue
						:previewLicenseDialog="previewLicenseDialog"
						:current_view="current_view"
						@call_api="toggle_add_update_api"
						:storeObj="storeObj"
						@close="
							current_view = 'LIST';
							show_tab = true;
						"
						@open_renewal_add="toggle_renewal_add"
						@preview_license_true="previewLicenseDialog = true"
					/>
				</el-col>
			</el-row>
		</div>
		<DeleteConfirmationVue
			:deleteDialog="deleteDialog"
			:confirmationObject="confirmationObject"
			@cancel="deleteDialog = false"
			@success="delete_api_toggle"
			:confirmationTitle="confirmationTitle"
			:calling_delete="calling_delete"
		/>
	</div>
</template>
<script>
import licenseManagementService from "../../../services/licenseManagementService";
import TaskSkeletonLoader from "../labourPlaninig/tasks/taskSkeletonLoader.vue";
import DeleteConfirmationVue from "./DeleteConfirmation.vue";
import AddLicenseVue from "./AddLicense.vue";
import LicenseSettingsVue from "./LicenseSettings.vue";
import { mapState, mapActions } from "vuex";
var moment = require("moment");
export default {
	components: {
		TaskSkeletonLoader,
		AddLicenseVue,
		DeleteConfirmationVue,
		LicenseSettingsVue,
	},
	data: () => ({
		moment: moment,
		previewLicenseDialog: false,
		isDomLoading: true,
		currentTabItems: [
			{ name: "Licenses", active: true },
			{ name: "Settings", active: false },
		],
		show_tab: true,
		search: "",
		licenseTableData: [],
		perPage: 10,
		currentPage: 1,
		current_view: "LIST",
		searched_Location: "",
		selected_Location: [],
		searched_license: "",
		selected_license: [],
		searched_Region: "",
		selected_Region: [],
		searched_SubRegion: "",
		selected_SubRegion: [],
		searched_Status: "",
		selected_Status: [],
		issue_date_order: "",
		expiry_date_order: "",
		confirmationObject: {},
		deleteDialog: false,
		confirmationTitle: "",
		storeObj: {},
		calling_delete: false,
		list_count: 0,
		pagination: {
			currentPage: 1,
		},
		all_licences: [],
		all_locations: [],
		all_regions: [],
		all_subregionss: [],
		all_status: [],
		searchTerm: "",
		debounceTimer: null,
	}),
	mounted() {
		this.isDomLoading = true;
		this.get_all_filters_data();
		this.get_all_licenses(
			this.currentPage,
			this.perPage,
			this.selected_Location,
			this.selected_license,
			this.selected_Region,
			this.selected_SubRegion,
			this.selected_Status
		);
		this.$nextTick(() => {
			this.$forceUpdate();
		});
	},
	watch: {
		currentTabItems: {
			handler(newVal, oldVal) {
				if (newVal[0].active) {
					this.get_all_filters_data();
					this.get_all_licenses(
						this.currentPage,
						this.perPage,
						this.selected_Location,
						this.selected_license,
						this.selected_Region,
						this.selected_SubRegion,
						this.selected_Status,
						this.search
					);
				}
			},
			deep: true, // Watch changes deeply in the array
		},
		perPage(newValue) {
			this.get_all_licenses(
				(this.currentPage = 1),
				newValue,
				this.selected_Location,
				this.selected_license,
				this.selected_Region,
				this.searched_SubRegion,
				this.selected_Status,
				this.search
			);
		},
		selected_Location(val) {
			this.get_all_licenses(
				1,
				this.perPage,
				val,
				this.selected_license,
				this.selected_Region,
				this.selected_SubRegion,
				this.selected_Status,
				this.search
			);
		},
		selected_license(val) {
			this.get_all_licenses(
				1,
				this.perPage,
				this.selected_Location,
				val,
				this.selected_Region,
				this.selected_SubRegion,
				this.selected_Status,
				this.search
			);
		},
		selected_Region(val) {
			this.get_all_licenses(
				1,
				this.perPage,
				this.selected_Location,
				this.selected_license,
				val,
				this.selected_SubRegion,
				this.selected_Status,
				this.search
			);
		},
		selected_SubRegion(val) {
			this.get_all_licenses(
				1,
				this.perPage,
				this.selected_Location,
				this.selected_license,
				this.selected_Region,
				val,
				this.selected_Status,
				this.search
			);
		},
		selected_Status(val) {
			this.get_all_licenses(
				1,
				this.perPage,
				this.selected_Location,
				this.selected_license,
				this.selected_Region,
				this.selected_SubRegion,
				val,
				this.search
			);
		},
		issue_date_order() {
			this.get_all_licenses(
				this.currentPage,
				this.perPage,
				this.selected_Location,
				this.selected_license,
				this.selected_Region,
				this.selected_SubRegion,
				this.selected_Status,
				this.search
			);
		},
		expiry_date_order() {
			this.get_all_licenses(
				this.currentPage,
				this.perPage,
				this.selected_Location,
				this.selected_license,
				this.selected_Region,
				this.selected_SubRegion,
				this.selected_Status,
				this.search
			);
		},
	},
	computed: {
		computedLicenseTableData() {
			let arr = [...this.licenseTableData];
			return arr;
		},
		startNumber() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		endNumber() {
			let end = Math.min(this.startNumber + this.perPage - 1, this.list_count);
			return end;
		},
		uniqueLocationNames() {
			let arr = [...new Set(this.all_locations)].flat();
			return arr;
		},
		uniqueLicense() {
			let arr = [...new Set(this.all_licences)].flat();
			return arr;
		},
		uniqueRegion() {
			let arr = [...new Set(this.all_regions)].flat();
			return arr;
		},
		uniqueSubRegion() {
			let arr = [...new Set(this.all_subregionss)].flat();
			return arr;
		},
		uniqueStatus() {
			let arr = [...new Set(this.all_status)].flat();
			return arr;
		},
	},
	methods: {
		...mapActions("CommonStore", [
			"addDownloadingReportCountAction",
			"removeDownloadingReportCountAction",
		]),
		handleInput() {
			clearTimeout(this.debounceTimer);
			this.debounceTimer = setTimeout(() => {
				this.get_all_licenses(
					this.currentPage,
					this.perPage,
					this.selected_Location,
					this.selected_license,
					this.selected_Region,
					this.selected_SubRegion,
					this.selected_Status,
					this.search
				);
			}, 500);
		},
		change_tab(idx) {
			for (let i = 0; i < this.currentTabItems.length; i++) {
				this.currentTabItems[i].active = false;
			}
			this.currentTabItems[idx].active = true;
		},
		get_all_filters_data() {
			let params = {
				filters: {},
			};
			licenseManagementService
				.listAllFiltersDataLicenses(params)
				.then((res) => {
					let response = JSON.parse(res.data);
					let valuesArray = [];
					for (let key in response) {
						if (key == "locations") this.all_locations.push(response[key]);
						if (key == "licenses") this.all_licences.push(response[key]);
						if (key == "regions") this.all_regions.push(response[key]);
						if (key == "subregions") this.all_subregionss.push(response[key]);
						if (key == "status") valuesArray.push(response[key]);
					}
					this.all_status = Object.values(valuesArray[0]);
				});
		},
		downloadCSV() {
			this.addDownloadingReportCountAction("Report");
			let params = {
				filters: {},
			};
			licenseManagementService
				.downloadCSVLicenses(params)
				.then((res) => {
					var fileURL = window.URL.createObjectURL(new Blob([res.data]));
					var fileLink = document.createElement("a");
					fileLink.href = fileURL;
					fileLink.setAttribute("download", `License Report.csv`); //or any other extension
					document.body.appendChild(fileLink);
					fileLink.click();
					this.removeDownloadingReportCountAction();
				})
				.catch((err) => {
					this.removeDownloadingReportCountAction();
				});
		},
		toggle_renewal_add(obj) {
			this.current_view = "";
			this.storeObj = {};
			setTimeout(() => {
				this.current_view = "RENEWAL_ADD";
				this.storeObj = obj;
			}, 50);
		},
		get_page(newPage) {
			this.currentPage = newPage;
			this.pagination.currentPage = newPage;
			this.get_all_licenses(
				newPage,
				this.perPage,
				this.selected_Location,
				this.selected_license,
				this.selected_Region,
				this.selected_SubRegion,
				this.selected_Status,
				this.search
			);
		},
		async get_all_licenses(
			page,
			per_page,
			location,
			license,
			region,
			subregion,
			status,
			search
		) {
			try {
				if (subregion === "") subregion = [];
				let sort_by = "";
				if (this.issue_date_order) sort_by = "issue_date";
				if (this.expiry_date_order) sort_by = "expiry_date";
				let allResults = [];
				for (let currentPage = 1; currentPage <= page; currentPage++) {
					const params = {
						filters: {},
						regions_list: region,
						subregions_list: subregion,
						locations_list: location,
						licenses_list: license,
						status_list: status,
						sort_by: sort_by,
						sort_on:
							sort_by === "issue_date"
								? this.issue_date_order
								: sort_by === "expiry_date"
								? this.expiry_date_order
								: "",
						search: search,
					};
					const res = await licenseManagementService.listAllLicenses(
						currentPage,
						per_page,
						params
					);
					const responseData = JSON.parse(res.data);
					if (currentPage === page) {
						this.list_count = responseData.count;
					}
					allResults = [...allResults, ...responseData.results];
				}
				this.licenseTableData = allResults;
				this.isDomLoading = false;
				this.$nextTick(() => {
					this.$forceUpdate();
				});
			} catch (error) {
				console.error("Error fetching licenses:", error);
			}
		},
		toggle_actions(action, item) {
			if (action == "ADD") {
				this.storeObj = {};
				this.current_view = action;
				this.show_tab = false;
			} else {
				this.fetch_data_by_id(action, item, action);
			}
		},
		fetch_data_by_id(action, item, type) {
			licenseManagementService.fetchLicensesDataByID(item.id).then((res) => {
				this.storeObj = JSON.parse(res.data);
				if (type == "EDIT" || type == "VIEW" || type == "RENEWAL_ADD") {
					this.current_view = action;
					this.show_tab = false;
				}
				if (type == "DELETE") {
					this.calling_delete = true;
					this.confirmationObject = this.storeObj;
					this.confirmationTitle = `Are you sure to delete the License ${this.storeObj.name}`;
					this.deleteDialog = true;
				}
				this.$forceUpdate();
			});
		},
		delete_api_toggle(item, calling_delete) {
			let params = {
				license: {
					id: item.id,
					name: item.name,
					location: item.location,
					issue_date: item.issue_date,
					description: item.description,
					expiry_date: item.expiry_date,
					alert_before: `${item.alert_before}`,
					escalation_type: "user",
					escalation_user: null,
					escalation_designations: [],
					archived: true,
				},
				license_attachments: item.attachments_info,
			};
			this.toggle_add_update_api(params, calling_delete);
			this.deleteDialog = false;
		},
		toggle_add_update_api(item, calling_delete) {
			licenseManagementService
				.addUpdateDeleteLicenses(item)
				.then((res) => {
					if (this.current_view == "ADD") {
						this.$notify.success({
							title: "Success",
							message: "License Added Successfully",
							type: "Success",
						});
					}
					if (this.current_view == "EDIT") {
						this.$notify.success({
							title: "Success",
							message: "License Edited Successfully",
							type: "Success",
						});
					}
					if (this.current_view == "RENEWAL_ADD") {
						this.$notify.success({
							title: "Success",
							message: "License Renewed Successfully",
							type: "Success",
						});
					}
					if (calling_delete) {
						this.$notify.success({
							title: "Success",
							message: "License Deleted Successfully",
							type: "Success",
						});
					}
					this.get_all_licenses(
						(this.currentPage = 1),
						this.perPage,
						this.selected_Location,
						this.selected_license,
						this.selected_Region,
						this.selected_SubRegion,
						this.selected_Status,
						this.search
					);
					this.current_view = "LIST";
					this.show_tab = true;
				})
				.catch((err) => {
					this.$notify.error({
						title: "Fail",
						message: `Failed with - ${err}`,
					});
				});
		},
	},
};
</script>

<style lang="scss">
.license {
	background-color: #f6f7f9;
	width: 100%;
	margin: auto;
	.license-table {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		width: 100% !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			min-height: 59vh;
			max-height: 59vh;
		}
	}
	.responsive-table {
		overflow-x: auto; /* Enable horizontal scrolling on small screens */
	}
	@media (max-width: 768px) {
		/* Adjust styles for small screens */
		.responsive-table {
			width: 100%; /* Make the table full width on small screens */
			display: block; /* Display table as block element for stacking on small screens */
		}
	}
}
.searchicon {
	padding-left: 20px;
	height: 40px;
	border-radius: 12px;
	border: none;
	width: 100%;
	background: #ffffff
		url("https://static.thenounproject.com/png/101791-200.png") no-repeat;
	background-size: 15px;
	background-position: -webkit-calc(100% - 20px) center;
	-webkit-transition: 0.5s;
	transition: 0.5s;
	outline: none;
	border: 1px solid rgb(209, 203, 203);
}
.search-col {
	width: 100%;
	margin-right: auto; /* Pushes the search input to the start of the row */
}
.button-class {
	height: 40px;
	background: #d26300;
	border-radius: 12px;
	color: #ffffff;
	overflow: visible;
	position: relative;
}
.button-class-white {
	height: 40px;
	background: #ffffff;
	border-radius: 12px;
	color: #d26300;
	border: 1px solid #d26300;
	overflow: visible;
	position: relative;
}
</style>
